export const deepCopy = <T>(obj: T): T => {
  return structuredClone(obj);
};

export type AwaitablePromise = {
  promise: Promise<unknown>;
  resolve: (value?: unknown) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  reject: (reason?: any) => void;
};

export const getAwaitablePromise = (): AwaitablePromise => {
  let resolveFunc: (value?: unknown) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let rejectFunc: (reason?: any) => void;
  const promise = new Promise((resolve, reject) => {
    resolveFunc = resolve;
    rejectFunc = reject;
  });
  return {
    promise,
    resolve: resolveFunc,
    reject: rejectFunc,
  };
};
